import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const ArticleRobots: FC = () => {
  const article = useAtomValue($CurrentAvailableArticleOrNull);

  if (!article) {
    return null;
  }

  return (
    <DynamicHead>
      <meta name="robots" content="max-image-preview:large, max-video-preview:-1" />
    </DynamicHead>
  );
};
